import { RowSystemPaymentMethodDto } from "@/dtos";
import { SystemPaymentMethod } from "@/entities";

export const formatRowSystemPaymentMethod = (systemPaymentMethods: SystemPaymentMethod[]): RowSystemPaymentMethodDto[] => {
    return systemPaymentMethods.map(x => {
        const row: RowSystemPaymentMethodDto = {
            ...x,
            system_label: x.system?.name,
            active: x.is_active ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}